var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pdf_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    x: 15,
    y: 24.75,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    x: 15,
    y: 29.25,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.5,
    x: 27,
    y: 24.75,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    x: 15,
    y: 35.25,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#3A8EF6",
    rx: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.995 18v-6h2.59q.668 0 1.17.264.5.264.779.74.278.479.278 1.117 0 .645-.287 1.116-.284.472-.8.727-.513.255-1.198.255H8.98v-1.266h1.219q.287 0 .489-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .112-.442.83.83 0 0 0-.112-.44.7.7 0 0 0-.313-.28 1.1 1.1 0 0 0-.49-.1h-.574V18zm7.723 0H13.41v-6h2.286q.925 0 1.6.36.675.358 1.042 1.032.37.67.37 1.608t-.367 1.611q-.366.671-1.037 1.032-.671.357-1.585.357m-.68-1.383h.621q.445 0 .76-.143a.97.97 0 0 0 .48-.495q.167-.352.167-.979t-.17-.979a.97.97 0 0 0-.492-.495 1.9 1.9 0 0 0-.791-.143h-.574zM19.46 18v-6h4.219v1.313h-2.59v1.03h2.332v1.313h-2.332V18z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pdf_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgPdf;